<div class="container full-height">
  <div class="row h-100">
    <div class="col align-items-center d-flex justify-content-md-center ">
      <div class="card border-0">
        <article class="card-body">
          <h4 class="card-title text-center mb-0 mt-1"><img alt="logo" class="center-block" src="assets/logo.gif"></h4>
          <hr>

          <ngb-alert *ngIf="success" [dismissible]="false" [type]="'success'">
            {{success}}
          </ngb-alert>
          <ngb-alert *ngIf="error" (close)="error=''" [type]="'danger'">
            {{error}}
          </ngb-alert>

          <form (ngSubmit)="onSubmit()" #recoverForm="ngForm" *ngIf="!success">

            <div class="form-group">
              <label for="recoveryIdentifier">To recover password, enter User ID or Email:</label>
              <input id="recoveryIdentifier" name="recoveryIdentifier" class="form-control" placeholder="User ID or Email"
                       required [(ngModel)]="recoveryIdentifierx" #recoveryIdentifierItem="ngModel">
            </div> <!-- form-group// -->

            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-block" [disabled]="!recoverForm.valid">Recover</button>
            </div> <!-- form-group// -->
          </form>
          <p class="text-center"><a [routerLink]="['/login']" class="btn">Back to login</a></p>
        </article>
      </div> <!-- card.// -->
    </div>
  </div>
</div>

